import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card, Image } from "react-bootstrap";
import { Line, PolarArea } from "react-chartjs-2";
import axios from "axios";
import { Chart, registerables } from "chart.js";

// Register all necessary Chart.js components
Chart.register(...registerables);

const ASOAudit = () => {
  const [packageName, setPackageName] = useState("");
  const [auditData, setAuditData] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "http://localhost:8000/api/google-scraper/aso-audit/",
        {
          package_name: packageName,
        }
      );
      setAuditData(response.data);
      setError(null);
    } catch (err) {
      setError("An error occurred while fetching the ASO audit data.");
      setAuditData(null);
    }
  };

  const renderAuditData = () => {
    if (!auditData) return null;

    // Check if sentiment_summary exists and is valid
    const sentimentSummary = auditData.sentiment_summary || { positive: 0, negative: 0, neutral: 0 };

    // Check if installs and reviews count exist and set default values if missing
    const installsCount = auditData.installs || 0;
    const reviewsCount = auditData.reviews_count || 0;

    // Preparing chart data
    const ratingData = {
      labels: ["Positive", "Negative", "Neutral"],
      datasets: [
        {
          label: "Sentiment Analysis",
          backgroundColor: ["#28a745", "#dc3545", "#ffc107"],
          data: [
            sentimentSummary.positive,
            sentimentSummary.negative,
            sentimentSummary.neutral,
          ],
        },
      ],
    };

    const installsData = {
      labels: ["Installs", "Reviews"],
      datasets: [
        {
          label: "App Metrics",
          backgroundColor: ["#17a2b8", "#17a2b8"],
          data: [installsCount, reviewsCount],
        },
      ],
    };

    return (
      <div>
        <h2 className="my-4 text-center">ASO Audit Results</h2>

        {/* Displaying App Icon and Title */}
        <Row className="mb-4 text-center">
          <Col>
            <Image src={auditData.icon_url} roundedCircle width="100" />
            <h4>{auditData.title}</h4>
            <p>{auditData.subtitle}</p>
          </Col>
        </Row>

        {/* Displaying Metrics as Charts */}
        <Row className="mb-4">
          <Col md={6} className="mb-4">
            <Card>
              <Card.Body>
                <Line data={ratingData} options={{ responsive: true }} />
                <h5 className="mt-3 text-center">Sentiment Analysis</h5>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} className="mb-4">
            <Card>
              <Card.Body>
                <PolarArea data={installsData} options={{ responsive: true }} />
                <h5 className="mt-3 text-center">App Installs vs Reviews</h5>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Displaying Screenshots */}
        <Row className="text-center">
          <h5>Screenshots</h5>
          {auditData.screenshots && auditData.screenshots.length > 0 ? (
            auditData.screenshots.map((screenshot, index) => (
              <Col md={4} key={index} className="mb-4">
                <Card>
                  <Card.Img variant="top" src={screenshot} />
                </Card>
              </Col>
            ))
          ) : (
            <Col>
              <p>No screenshots available.</p>
            </Col>
          )}
        </Row>

        {/* Additional Information */}
        <Row className="mt-4">
          <Col>
            <Card>
              <Card.Body>
                <h5>Additional Info</h5>
                <p><strong>Category:</strong> {auditData.genre || "N/A"}</p>
                <p><strong>Developer:</strong> {auditData.developer || "N/A"}</p>
                <p><strong>Installs:</strong> {auditData.installs || "N/A"}</p>
                <p><strong>Last Updated:</strong> {auditData.updated || "N/A"}</p>
                <p><strong>Rating:</strong> {auditData.rating || "N/A"}</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <Container className="mt-5">
      <Form onSubmit={handleSubmit}>
        <Row className="justify-content-center">
          <Col md={8}>
            <Form.Group controlId="packageName">
              <Form.Label>Enter the App Package Name:</Form.Label>
              <Form.Control
                type="text"
                placeholder="com.example.app"
                value={packageName}
                onChange={(e) => setPackageName(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={4} className="align-self-end">
            <Button type="submit" className="btn btn-primary mt-2">
              Fetch ASO Audit
            </Button>
          </Col>
        </Row>
      </Form>
      

      {/* Error Message */}
      {error && (
        <div className="alert alert-danger text-center mt-4">{error}</div>
      )}

      {/* Displaying Audit Data */}
      {auditData && renderAuditData()}
    </Container>
  );
};

export default ASOAudit;


